import { createSelector } from 'reselect';

import { getBodyData } from 'store/selectors';
import { RECOMMENDATION_TABS } from 'store/ProductDetails/recommendationTabs/constants';

const getRecommendationTabs = (state: any) => getBodyData(state).recommendationTabs;
export const getRecommendationTabsIsFetching = (state: any) =>
  getRecommendationTabs(state).isFetching;
export const getRecommendationTabsActiveTab = (state: any) =>
  getRecommendationTabs(state).activeTab;

export const getRecommendationTabsData = createSelector(getRecommendationTabs, (state) => {
  const { activeTab, data } = state;
  return activeTab ? (data[activeTab]?.devices ?? []) : [];
});

export const getRecommendationTabsStrategyName = createSelector(getRecommendationTabs, (state) => {
  const { activeTab, data } = state;
  return activeTab ? (data[activeTab]?.strategyName ?? '') : '';
});

export const getRecommendationTabsStrategyMessage = createSelector(
  getRecommendationTabs,
  (state) => {
    const { activeTab, data } = state;
    return activeTab ? (data[activeTab]?.strategyMessage ?? '') : '';
  },
);

export const getRecommendationTabsPlacement = createSelector(getRecommendationTabs, (state) => {
  const { activeTab, data } = state;
  return activeTab ? (data[activeTab]?.placement ?? '') : '';
});

export const getRecommendationCategories = createSelector(
  getRecommendationTabsActiveTab,
  (activeTabId) => {
    return RECOMMENDATION_TABS.map((tab) => ({ ...tab, isActive: tab.id === activeTabId }));
  },
);
